export default __webpack_public_path__ + "static/media/capaLogin.4513a633.png";